import { combineReducers } from "redux";
import consentReducer from "./consent";

export default combineReducers({
  paths: (state = {}) => state,
  consentReducer,
});
